import { render, staticRenderFns } from "./Invoice_Delete.vue?vue&type=template&id=efb8b8cc&scoped=true&"
import script from "./Invoice_Delete.vue?vue&type=script&lang=js&"
export * from "./Invoice_Delete.vue?vue&type=script&lang=js&"
import style0 from "./Invoice_Delete.vue?vue&type=style&index=0&id=efb8b8cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8b8cc",
  null
  
)

export default component.exports